import { useCallback, useEffect } from 'react'
import { batch, useSignal } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { companyUsers, dateRange, userData } from '@signals'
import { BACKEND_APIS } from '@constants'


export default function useSearchAnalyticsMonthInfo() {
	const searches = useSignal(0)
	const columnChartData = useSignal({})
	const isMonthLoading = useSignal(false)

	const getMonthInfo = useCallback(() => {
		isMonthLoading.value = true
		postSubmit(`${BACKEND_APIS.SEARCH_ANALYTICS}/month`, {
			user: userData.value.username,
			uid: companyUsers.value
		}).then(({ bookingDates, monthSearches, results, series }) => {
			isMonthLoading.value = false
			batch(() => {
				searches.value = monthSearches
				columnChartData.value = {
					bookingDates: bookingDates,
					results: results,
					series: series
				}
			})
		}).catch(() => {
			isMonthLoading.value = false
		})
	}, [JSON.stringify(companyUsers.value)])

	useEffect(() => {
		getMonthInfo()
	}, [JSON.stringify(companyUsers.value), JSON.stringify(dateRange.value)])

	return {
		monthSearches: searches.value,
		columnChartData: columnChartData.value,
		isMonthLoading: isMonthLoading.value,
	}
}